import { render, staticRenderFns } from "./blinkist-stats.vue?vue&type=template&id=f76c47f8&"
import script from "./blinkist-stats.vue?vue&type=script&lang=js&"
export * from "./blinkist-stats.vue?vue&type=script&lang=js&"
import style0 from "./blinkist-stats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports